import { render, staticRenderFns } from "./ProjectItemRealback.vue?vue&type=template&id=066ec483&scoped=true"
import script from "./ProjectItemRealback.vue?vue&type=script&lang=js"
export * from "./ProjectItemRealback.vue?vue&type=script&lang=js"
import style0 from "./ProjectItemRealback.vue?vue&type=style&index=0&id=066ec483&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066ec483",
  null
  
)

export default component.exports